import React, { useContext } from 'react';
import Stepper from '../stepper';
import Currency from 'components/currency';
import { ThemeContext } from 'context/themeContext';
import { useTranslation } from 'react-i18next';
import {
  Content,
  OrderName,
  OrderDetails,
  OrderItems,
  OrderItem,
  OrderPrice,
  StyledSubTitle,
  DownloadIcon,
  DownloadWrapper
} from './css';
import { RFQBadge } from '../../components/wrapper';

const App = (props) => {
  const { theme, rtlDirection } = useContext(ThemeContext);
  const { selectedOrder, hub } = props;
  const { t } = useTranslation();
  let infillDesc='';
  if(selectedOrder?.print_params?.infill_percentage!=undefined){
    infillDesc=` - ${selectedOrder.print_params.infill_percentage}% ${t('infill')}`;
  }
  selectedOrder.infillDesc=infillDesc;

  return (
    <>
      <Stepper status={selectedOrder.status} />
      <Content>
        <StyledSubTitle theme={theme}>{t('dashboard.order modal.3D Model')}</StyledSubTitle>
        <OrderDetails theme={theme}>
          <OrderName rtlDirection={rtlDirection} theme={theme}>
            {selectedOrder.file.original_name}
          </OrderName>
          <OrderItems rtlDirection={rtlDirection}>
            <OrderItem>
              {t('dashboard.order modal.Material / Color') +
                ': ' +
                selectedOrder.material.name +
                ' ' +
                selectedOrder.color.name}
            </OrderItem>
            {selectedOrder?.material?.material_type =='time' && (
              <OrderItem>
                { t('dashboard.order modal.Quality')+
                ': '+
                selectedOrder?.quality.value*1000+' '+t('microns')+
                selectedOrder?.infillDesc}
              </OrderItem>


            )}
            
            
            <OrderItem>
              {t('dashboard.order modal.Size') +
                ': ' +
                selectedOrder.file.scales.x.toFixed(2) +
                ' x ' +
                selectedOrder.file.scales.y.toFixed(2) +
                ' x ' +
                selectedOrder.file?.scales.z?.toFixed(2) +
                ' '+
                selectedOrder?.unit} 
            </OrderItem>
            <OrderItem>
              {t('dashboard.order modal.Quantity') +
                ': ' +
                selectedOrder.quantity
              }
            </OrderItem>
            <OrderItem>
              {t('dashboard.order modal.Weight') +
                ': ' +
                selectedOrder.weight
              }
            </OrderItem>
          </OrderItems>
          <OrderPrice rtlDirection={rtlDirection} theme={theme}>
            {/* <Currency value={selectedOrder.price} /> this is changed to below one by qazal instead of the above line for preventing of floating point*/}
            { selectedOrder.status === 9 ?  
                <RFQBadge theme={theme}>RFQ</RFQBadge> : 
                <Currency
                  value={
                    Number.isInteger(selectedOrder.price)
                      ? selectedOrder.price
                      : parseFloat(selectedOrder.price).toFixed(2)
                  }
                />
              }
            
          </OrderPrice>
          <OrderItem>
            <a href={`${process.env.REACT_APP_STATISTIC_SERVICE_URL}/stl/${selectedOrder.file.original_file_path}?original_name=${selectedOrder.file.original_name}`} >
              <DownloadWrapper onClick={(e) => e.stopPropagation()} theme={theme} rtlDirection={rtlDirection}>
                <DownloadIcon className="icon-second-download" theme={theme} />
              </DownloadWrapper>
            </a>
          </OrderItem>
        </OrderDetails>
      </Content>
    </>
  );
};

export default App;
